import { Icon, IconProps } from "@chakra-ui/react";
import cdsColors from "theme/cdsColors";

export default function CaminoSendNow(props: IconProps) {
  return (
    <Icon
      viewBox="0 0 16 16"
      fill="none"
      {...props}
    >
      <path
        d="M13.2 8.61666L2.93333 12.95C2.71111 13.0389 2.5 13.0193 2.3 12.8913C2.1 12.7633 2 12.5773 2 12.3333V3.66666C2 3.42222 2.1 3.23622 2.3 3.10866C2.5 2.98111 2.71111 2.96155 2.93333 3.05L13.2 7.38333C13.4778 7.50555 13.6167 7.71111 13.6167 8C13.6167 8.28889 13.4778 8.49444 13.2 8.61666ZM3.33333 11.3333L11.2333 8L3.33333 4.66666V7L7.33333 8L3.33333 9V11.3333Z"
        fill={cdsColors.cdsGrey[800]}
      />
    </Icon>
  );
}
